module.exports = __webpack_public_path__ + "2d2284289cc269986057ae6b115c5a56.jpg";